import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from 'react-router-dom';
import { AuthGuard } from '../components/AuthGuard';
import { ColorMatchGame } from '../games/color-match/game';
import { DoubleDecisionGame } from '../games/double-decision/game';
import { FaceFactsGame } from '../games/face-facts/game';
import { FaceToFaceGame } from '../games/face-to-face/game';
import { HawkEyeGame } from '../games/hawk-eye/game';
import { InhibitionGame } from '../games/inhibition/game';
import { MemoryGridGame } from '../games/memory-grid/game';
import { MentalMapGame } from '../games/mental-map/game';
import { MindBenderGame } from '../games/mind-bender/game';
import { PathFinderGame } from '../games/path-finder/game';
import { SoundSweepsGame } from '../games/sound-sweeps/game';
import { VisualSweepsGame } from '../games/visual-sweeps/game';
import { TargetTrackerGame } from '../games/target-tracker/game';
import { FreezeFrameGame } from '../games/freeze-frame/game';
import { MemoryMatrixGame } from '../games/memory-matrix/game';
import { SequenceGame } from '../games/sequence/game';
import { SpeedMatchGame } from '../games/speed-match/game';
import { ReactionSportGame } from '../games/reaction-sport/game';
import { EyesTestToMGame } from '../games/eyes-test-tom/game';
import { FauxPasDetectionGame } from '../games/faux-pas-detection/game';
import { TrueNorthGame } from '../games/true-north/game';
import { ThreeDRotationGame } from '../games/3d-rotation/game';
import { LogicTrailGame } from '../games/logic-trail/game';
import { NumberCrunchGame } from '../games/number-crunch/game';
import { ThreeDMotGame } from '../games/3d-mot/game';
import { DividedAttentionGame } from '../games/divided-attention/game';
import { LostInMigrationGame } from '../games/lost-in-migration/game';
import { TrainOfThoughtGame } from '../games/train-of-thought/game';
import { JuggleFactorGame } from '../games/juggle-factor/game';
import { WordPyramidsGame } from '../games/word-pyramids/game';
import { MindsEyeGame } from '../games/minds-eye/game';
import { ProspectiveMemoryGame } from '../games/prospective-memory/game';
import { AlternativeUsesGame } from '../games/alternative-uses/game';
import { BartRiskGame } from '../games/bart-risk/game';
import { CognitiveReappraisalGame } from '../games/cognitive-reappraisal/game';
import { JolConfidenceGame } from '../games/jol-confidence/game';
import { SymbolCodingGame } from '../games/symbol-coding/game';
import { TrailMakingAGame } from '../games/trail-making-a/game';
import { DigitSpanBackwardGame } from '../games/digit-span-backward/game';
import { WcstGame } from '../games/wcst/game';
import { AntisaccadeGame } from '../games/antisaccade/game';
import { StopSignalGame } from '../games/stop-signal/game';
import { VerbalFluencyGame } from '../games/verbal-fluency/game';
import { SettingsPage } from '../pages/settings';
import { ProfilePage } from '../pages/profile';
import { PrivacyPage } from '../pages/privacy';
import { LibraryIndex } from '../pages/library';
import { CategoryDetail } from '../pages/library/CategoryDetail';
import { GameDetail } from '../pages/library/GameDetail';
import { SessionPlayer } from '../pages/session/SessionPlayer';
import { SessionResults } from '../pages/session/SessionResults';
import { Navigate } from 'react-router-dom';
function protect(element) {
    return _jsx(AuthGuard, { children: element });
}
export function GameRoutes() {
    return [
        _jsx(Route, { path: "/play", element: _jsx(Navigate, { to: "/library", replace: true }) }, "play"),
        _jsx(Route, { path: "/play/double-decision", element: protect(_jsx(DoubleDecisionGame, {})) }, "double-decision"),
        _jsx(Route, { path: "/play/memory-grid", element: protect(_jsx(MemoryGridGame, {})) }, "memory-grid"),
        _jsx(Route, { path: "/play/visual-sweeps", element: protect(_jsx(VisualSweepsGame, {})) }, "visual-sweeps"),
        _jsx(Route, { path: "/play/hawk-eye", element: protect(_jsx(HawkEyeGame, {})) }, "hawk-eye"),
        _jsx(Route, { path: "/play/color-match", element: protect(_jsx(ColorMatchGame, {})) }, "color-match"),
        _jsx(Route, { path: "/play/path-finder", element: protect(_jsx(PathFinderGame, {})) }, "path-finder"),
        _jsx(Route, { path: "/play/sound-sweeps", element: protect(_jsx(SoundSweepsGame, {})) }, "sound-sweeps"),
        _jsx(Route, { path: "/play/inhibition", element: protect(_jsx(InhibitionGame, {})) }, "inhibition"),
        _jsx(Route, { path: "/play/face-facts", element: protect(_jsx(FaceFactsGame, {})) }, "face-facts"),
        _jsx(Route, { path: "/play/face-to-face", element: protect(_jsx(FaceToFaceGame, {})) }, "face-to-face"),
        _jsx(Route, { path: "/play/mental-map", element: protect(_jsx(MentalMapGame, {})) }, "mental-map"),
        _jsx(Route, { path: "/play/mind-bender", element: protect(_jsx(MindBenderGame, {})) }, "mind-bender"),
        _jsx(Route, { path: "/play/target-tracker", element: protect(_jsx(TargetTrackerGame, {})) }, "target-tracker"),
        _jsx(Route, { path: "/play/freeze-frame", element: protect(_jsx(FreezeFrameGame, {})) }, "freeze-frame"),
        _jsx(Route, { path: "/play/memory-matrix", element: protect(_jsx(MemoryMatrixGame, {})) }, "memory-matrix"),
        _jsx(Route, { path: "/play/sequence", element: protect(_jsx(SequenceGame, {})) }, "sequence"),
        _jsx(Route, { path: "/play/speed-match", element: protect(_jsx(SpeedMatchGame, {})) }, "speed-match"),
        _jsx(Route, { path: "/play/reaction-sport", element: protect(_jsx(ReactionSportGame, {})) }, "reaction-sport"),
        _jsx(Route, { path: "/play/eyes-test-tom", element: protect(_jsx(EyesTestToMGame, {})) }, "eyes-test-tom"),
        _jsx(Route, { path: "/play/faux-pas-detection", element: protect(_jsx(FauxPasDetectionGame, {})) }, "faux-pas-detection"),
        _jsx(Route, { path: "/play/true-north", element: protect(_jsx(TrueNorthGame, {})) }, "true-north"),
        _jsx(Route, { path: "/play/3d-rotation", element: protect(_jsx(ThreeDRotationGame, {})) }, "3d-rotation"),
        _jsx(Route, { path: "/play/logic-trail", element: protect(_jsx(LogicTrailGame, {})) }, "logic-trail"),
        _jsx(Route, { path: "/play/number-crunch", element: protect(_jsx(NumberCrunchGame, {})) }, "number-crunch"),
        _jsx(Route, { path: "/play/3d-mot", element: protect(_jsx(ThreeDMotGame, {})) }, "3d-mot"),
        _jsx(Route, { path: "/play/divided-attention", element: protect(_jsx(DividedAttentionGame, {})) }, "divided-attention"),
        _jsx(Route, { path: "/play/lost-in-migration", element: protect(_jsx(LostInMigrationGame, {})) }, "lost-in-migration"),
        _jsx(Route, { path: "/play/train-of-thought", element: protect(_jsx(TrainOfThoughtGame, {})) }, "train-of-thought"),
        _jsx(Route, { path: "/play/juggle-factor", element: protect(_jsx(JuggleFactorGame, {})) }, "juggle-factor"),
        _jsx(Route, { path: "/play/word-pyramids", element: protect(_jsx(WordPyramidsGame, {})) }, "word-pyramids"),
        _jsx(Route, { path: "/play/minds-eye", element: protect(_jsx(MindsEyeGame, {})) }, "minds-eye"),
        _jsx(Route, { path: "/play/prospective-memory", element: protect(_jsx(ProspectiveMemoryGame, {})) }, "prospective-memory"),
        _jsx(Route, { path: "/play/alternative-uses", element: protect(_jsx(AlternativeUsesGame, {})) }, "alternative-uses"),
        _jsx(Route, { path: "/play/bart-risk", element: protect(_jsx(BartRiskGame, {})) }, "bart-risk"),
        _jsx(Route, { path: "/play/cognitive-reappraisal", element: protect(_jsx(CognitiveReappraisalGame, {})) }, "cognitive-reappraisal"),
        _jsx(Route, { path: "/play/jol-confidence", element: protect(_jsx(JolConfidenceGame, {})) }, "jol-confidence"),
        _jsx(Route, { path: "/play/symbol-coding", element: protect(_jsx(SymbolCodingGame, {})) }, "symbol-coding"),
        _jsx(Route, { path: "/play/trail-making-a", element: protect(_jsx(TrailMakingAGame, {})) }, "trail-making-a"),
        _jsx(Route, { path: "/play/digit-span-backward", element: protect(_jsx(DigitSpanBackwardGame, {})) }, "digit-span-backward"),
        _jsx(Route, { path: "/play/wcst", element: protect(_jsx(WcstGame, {})) }, "wcst"),
        _jsx(Route, { path: "/play/antisaccade", element: protect(_jsx(AntisaccadeGame, {})) }, "antisaccade"),
        _jsx(Route, { path: "/play/stop-signal", element: protect(_jsx(StopSignalGame, {})) }, "stop-signal"),
        _jsx(Route, { path: "/play/verbal-fluency", element: protect(_jsx(VerbalFluencyGame, {})) }, "verbal-fluency"),
        _jsx(Route, { path: "/library", element: protect(_jsx(LibraryIndex, {})) }, "library-index"),
        _jsx(Route, { path: "/library/:cat", element: protect(_jsx(CategoryDetail, {})) }, "library-cat"),
        _jsx(Route, { path: "/library/:cat/:game", element: protect(_jsx(GameDetail, {})) }, "library-game"),
        _jsx(Route, { path: "/session/play", element: protect(_jsx(SessionPlayer, {})) }, "session-play"),
        _jsx(Route, { path: "/session/results", element: protect(_jsx(SessionResults, {})) }, "session-results"),
        _jsx(Route, { path: "/settings", element: protect(_jsx(SettingsPage, {})) }, "settings"),
        _jsx(Route, { path: "/profile", element: protect(_jsx(ProfilePage, {})) }, "profile"),
        _jsx(Route, { path: "/privacy", element: protect(_jsx(PrivacyPage, {})) }, "privacy"),
    ];
}
/**
 * Path manifeste — utile pour generators / tests / sitemaps.
 */
export const GAME_PATHS = {
    selector: '/play',
    doubleDecision: '/play/double-decision',
    memoryGrid: '/play/memory-grid',
    visualSweeps: '/play/visual-sweeps',
    hawkEye: '/play/hawk-eye',
    colorMatch: '/play/color-match',
    pathFinder: '/play/path-finder',
    soundSweeps: '/play/sound-sweeps',
    inhibition: '/play/inhibition',
    faceFacts: '/play/face-facts',
    faceToFace: '/play/face-to-face',
    mentalMap: '/play/mental-map',
    mindBender: '/play/mind-bender',
    targetTracker: '/play/target-tracker',
    freezeFrame: '/play/freeze-frame',
    memoryMatrix: '/play/memory-matrix',
    sequence: '/play/sequence',
    speedMatch: '/play/speed-match',
    reactionSport: '/play/reaction-sport',
    eyesTestTom: '/play/eyes-test-tom',
    fauxPasDetection: '/play/faux-pas-detection',
    trueNorth: '/play/true-north',
    rotation3d: '/play/3d-rotation',
    logicTrail: '/play/logic-trail',
    numberCrunch: '/play/number-crunch',
    threeDMot: '/play/3d-mot',
    dividedAttention: '/play/divided-attention',
    lostInMigration: '/play/lost-in-migration',
    trainOfThought: '/play/train-of-thought',
    juggleFactor: '/play/juggle-factor',
    wordPyramids: '/play/word-pyramids',
    mindsEye: '/play/minds-eye',
    prospectiveMemory: '/play/prospective-memory',
    alternativeUses: '/play/alternative-uses',
    bartRisk: '/play/bart-risk',
    cognitiveReappraisal: '/play/cognitive-reappraisal',
    jolConfidence: '/play/jol-confidence',
    symbolCoding: '/play/symbol-coding',
    trailMakingA: '/play/trail-making-a',
    digitSpanBackward: '/play/digit-span-backward',
    wcst: '/play/wcst',
    antisaccade: '/play/antisaccade',
    stopSignal: '/play/stop-signal',
    verbalFluency: '/play/verbal-fluency',
    library: '/library',
    sessionPlay: '/session/play',
    sessionResults: '/session/results',
};
//# sourceMappingURL=router.js.map